import React from "react"

class AccommodationsDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row.reservation_segments && this.props.row.reservation_segments.length > 0) {
      var rooms = this.props.row.reservation_segments.map(function (segment) {
        if (!segment.child) {
          return (
            <li key={segment.id}>
              {segment.room_type.code}
            </li>
          );
        }
      });
      return (
        <div>
          <ul className="reservation-rooms">
            {rooms}
          </ul>
        </div>
      );
    } else {
      return (
        <div className="text-center"><span className="none">{I18n.t('none')}</span></div>
      );
    }
  }

};

export default AccommodationsDataType